<template>
  
    <PrivacyPolicySenso v-if="appName == 'senso'" />
    <PrivacyPolicyImprove v-else />
  
</template>

<script>
import PrivacyPolicyImprove from '@/components/PrivacyPolicyImprove.vue';
import PrivacyPolicySenso from '@/components/PrivacyPolicySenso.vue';


export default {
  name: "PrivacyPolicy",
  components: {
    PrivacyPolicyImprove,
    PrivacyPolicySenso,
  },
  data() {
    return {
      appName: this.$globalConfig.APP_NAME
    };
  },
};
</script>